import { z } from "zod";

/** Optional numeric field that a cleared input (`""`) leaves unset rather than 0. */
const optionalCount = z.union([z.literal(""), z.coerce.number().positive("Enter a number greater than zero.")]);

export const aiListingSchema = z.object({
  address: z.string().trim().min(3, "Property address is required."),
  beds: optionalCount,
  baths: optionalCount,
  sqft: optionalCount,
  features: z.string().trim().max(1_000, "Keep features under 1,000 characters.").default(""),
  tone: z.string().trim().min(1, "Pick a tone."),
});
